import { PeriodSelect } from '@/components/TaxReport/PeriodSelect';
import { DateRangePickerMobile } from '@/kit/DatePickers/DateRangePickerMobile';
import { ActionMenu } from '@/components/TaxReport/ActionMenu';
import s from './index.module.scss';

export const FilterViewMobile = ({ params, onDateChange }) => {
  return (
    <div className={s.wrapper}>
      <div className={s.list}>
        <div className={s.scroll}>
          <PeriodSelect mobile range={params.range} onChange={onDateChange} />
          <DateRangePickerMobile
            range={params.range}
            setRange={onDateChange}
            maxDate={new Date()}
          />
        </div>
        <div className={s.fade_right} />
      </div>
      <ActionMenu />
    </div>
  );
};
